import Vue from 'vue';
import store from './../../store';

// When the request succeeds
const success = (response, context) => {
    context.rentals = response.data.rentals;
    context.monthsWithRentals = response.data.months;
    let monthsRentalLength = Object.keys(response.data.months).length;
    for (let j in context.monthsWithRentals){
      if (!context.monthsWithRentals.hasOwnProperty(j)) continue;

      let rentalsLength = context.monthsWithRentals[j].rentals.length;
      for(let k = 0; k < rentalsLength; k++) {
        context.selectedRental = context.monthsWithRentals[j]['rentals'][0]['id'];
        context.monthsWithRentals[j]['rentals'][k].googleReview = 0;
        context.monthsWithRentals[j]['rentals'][k].bookingReview = 0;
        context.monthsWithRentals[j]['rentals'][k].airbnbReview  = 0;
        context.monthsWithRentals[j]['rentals'][k].expediaReview = 0;
        if(Object.keys(context.monthsWithRentals[j]['rentals'][k].reviews).length > 0){

          //Google Reviews
          if(context.monthsWithRentals[j]['rentals'][k].reviews.google){
            let length = context.monthsWithRentals[j]['rentals'][k].reviews.google.listings.length;
            for(let i = 0; i < length; i++){
              let len = context.monthsWithRentals[j]['rentals'][k].reviews.google.listings[i].data.length;
              if(len > 0){
                let googleReviews = context.monthsWithRentals[j]['rentals'][k].reviews.google.listings[i].data[len - 1];
                context.monthsWithRentals[j]['rentals'][k].googleReview = context.monthsWithRentals[j]['rentals'][k].googleReview + (googleReviews && googleReviews.rating) ? googleReviews.rating : 0;
              }
            }

            if(context.monthsWithRentals[j]['rentals'][k].googleReview == 'N / A' || context.monthsWithRentals[j]['rentals'][k].googleReview == 0){
              context.monthsWithRentals[j]['rentals'][k].googleReview = 'N / A';
            }else {
              context.monthsWithRentals[j]['rentals'][k].googleReview = parseFloat(parseFloat(context.monthsWithRentals[j]['rentals'][k].googleReview.replace(',', '.'))/length ).toFixed(1) + ' / 5';
            }
          }

          //  Expedia Reviews
          if(context.monthsWithRentals[j]['rentals'][k].reviews.expedia){
            let length = context.monthsWithRentals[j]['rentals'][k].reviews.expedia.listings.length;

            for(let i = 0; i < length; i++){
              let len = context.monthsWithRentals[j]['rentals'][k].reviews.expedia.listings[i].data.length;
              if(len > 0){
                let expediaReviews = context.monthsWithRentals[j]['rentals'][k].reviews.expedia.listings[i].data[len-1];
                context.monthsWithRentals[j]['rentals'][k].expediaReview = context.monthsWithRentals[j]['rentals'][k].expediaReview + (expediaReviews && expediaReviews.rating) ? expediaReviews.rating.replace(',', '.') : 0;
              }
            }

            if(context.monthsWithRentals[j]['rentals'][k].expediaReview == 'N / A' || context.monthsWithRentals[j]['rentals'][k].expediaReview == 0){
              context.monthsWithRentals[j]['rentals'][k].expediaReview = 'N / A';
            }else{
              context.monthsWithRentals[j]['rentals'][k].expediaReview = (parseFloat(context.monthsWithRentals[j]['rentals'][k].expediaReview/length).toFixed(1) )  + ' / 5';
            }
          }

          //Booking Reviews
          if(context.monthsWithRentals[j]['rentals'][k].reviews.booking){
            let length = context.monthsWithRentals[j]['rentals'][k].reviews.booking.listings.length;

            for(let i = 0; i < length; i++){
              let len = context.monthsWithRentals[j]['rentals'][k].reviews.booking.listings[i].data.length;
              if(len > 0){
                let bookingReviews = context.monthsWithRentals[j]['rentals'][k].reviews.booking.listings[i].data[len-1];
                context.monthsWithRentals[j]['rentals'][k].bookingReview = context.monthsWithRentals[j].bookingReview + (bookingReviews && bookingReviews.rating) ? bookingReviews.rating : 0;
              }
            }

            if(context.monthsWithRentals[j]['rentals'][k].bookingReview == 'N / A' || context.monthsWithRentals[j]['rentals'][k].bookingReview == 0){
              context.monthsWithRentals[j]['rentals'][k].bookingReview = 'N / A';
            }else{
              context.monthsWithRentals[j]['rentals'][k].bookingReview = parseFloat(parseFloat(context.monthsWithRentals[j]['rentals'][k].bookingReview).toFixed(1)/length).toFixed(1) + ' / 10';
            }
          }

          //Airbnb
          if(context.monthsWithRentals[j]['rentals'][k].reviews.airbnb){
            let length = context.monthsWithRentals[j]['rentals'][k].reviews.airbnb.listings.length;
            for(let i = 0; i < length; i++){
              let len = context.monthsWithRentals[j]['rentals'][k].reviews.airbnb.listings[i].data.length;
              if(len > 0){
                let airbnbReviews = context.monthsWithRentals[j]['rentals'][k].reviews.airbnb.listings[i].data[len-1];
                context.monthsWithRentals[j]['rentals'][k].airbnbReview = context.monthsWithRentals[j]['rentals'][k].airbnbReview + ((airbnbReviews && airbnbReviews.rating) ? parseFloat(airbnbReviews.rating) : 0);
              }
            }


            if(context.monthsWithRentals[j]['rentals'][k].airbnbReview == 'N / A' || context.monthsWithRentals[j]['rentals'][k].airbnbReview == 0){
              context.monthsWithRentals[j]['rentals'][k].airbnbReview = 'N / A';
            }else{
              context.monthsWithRentals[j]['rentals'][k].airbnbReview = (parseFloat(context.monthsWithRentals[j]['rentals'][k].airbnbReview/length)* 5) / 100 + ' / 5';
            }
          }
        }
      }
      context.loading = false;
      }
    };

// When the request fails
const failed = (error, context) => {
    context.loading = false;
    toastr.error(error)
};

export default (url, context) => {
    return Vue.$http.get(url)
        .then((response) => {
            if (response.status === 200) {
                success(response, context);
            }
        })
        .catch((error) => {
            failed(error, context);
        });
};



// WEBPACK FOOTER //
// ./src/app/services/analytics/getRentalsTab.js